import { IValueData } from 'data';
import { EEventType } from './../../enums/EEventType';
import styles from './index.module.less';
import template from './index.art';
import OY from '../../types/OY';
import { IOYFilterBarProps, IOYFilterBarState, EFilterBarEvent, IOYFilterBarTag, EOperation } from './const';
import { jeact } from '../../decorators/jeact';
import OYFilterBarSaveList from './components/OYFilterBarSaveList';
import { ISaveListData } from './components/OYFilterBarSaveList/const';

@jeact({ autoRender: true })
export default class OYFilterBar extends OY<IOYFilterBarProps, IOYFilterBarState> {
  static displayName = 'OYFilterBar';

  static defaultProps: Partial<IOYFilterBarProps> = {
    channel: [],
    count: 0,
    totalWeight: 0,
    operations: [EOperation.Reset, EOperation.Save, EOperation.New, EOperation.SaveList, EOperation.Feedback],
    tags: [],
    fastQueryList: [],
    showNewBtn: false
  }

  state: IOYFilterBarState = {
    isRenderChannel: false
  };

  $node = {
    center_search_tooltip: $()
  }

  saveList!: OYFilterBarSaveList;

  getDerivedStateFromProps(props: IOYFilterBarProps, state: IOYFilterBarState) {
    const { channel, channelValue } = props;
    const isRenderChannel = !!(channel || []).length && !!(channelValue || []).length;
    return { ...state, isRenderChannel };
  }

  render() {
    const isHideFilter = localStorage.getItem("IS_HIDE_FILTER_TPL");
    return template({ props: this.props, state: this.state, styles, isHideFilter });
  }

  renderSaveList() {
    const { fastQueryList, activedSaveName } = this.props;
    this.saveList = this.$el.find('oy-filter-bar-save-list').OYFilterBarSaveList({
      data: fastQueryList,
      activedSaveName,
      onClick: (value: any, index: number) => {
        const list: ISaveListData[] = JSON.parse(JSON.stringify(this.props.fastQueryList))
        this.$emit(EFilterBarEvent.onSaveListClick, value, index, list)
      },
      onRemove: (value: any, index: number) => {
        const list: ISaveListData[] = JSON.parse(JSON.stringify(this.props.fastQueryList))
        this.$emit(EFilterBarEvent.onSaveListDelete, value, index, list)
      }
    })
  }

  renderTags() {
    this.$el.find('oy-tag').each((_idx, element) => {
      const $elment = $(element);
      const index = $elment.data('index');
      const data = this.props.tags![index];
      const tag = $elment.OYTag({
        label: data.title,
        allRemoveable: true,
        onRemove: () => {
          tag.$parent.remove();
          this.$emit(EEventType.onRemove, data, index)
        }
      })
    })
  }

  renderOYFilterBarChannel() {
    const { channel, channelValue } = this.props;
    if (this.state.isRenderChannel) {
      this.$el.find('oy-filter-bar-channel').OYFilterBarChannel({
        value: channelValue![0],
        data: channel,
        onClick: (value: IValueData, index: number) => {
          this.$emit(EFilterBarEvent.onChannelClick, value, index)
        }
      })
    }
  }

  setSaveList(data: ISaveListData[]) {
    if (this.saveList) {
      this.props.showFastQueryList = true;
      this.props.fastQueryList = data;
      this.saveList.setProp({ data })
    }
  }

  getTags(): IOYFilterBarTag[] {
    return JSON.parse(JSON.stringify(this.props.tags));
  }

  setNode() {
    this.$node = {
      center_search_tooltip: this.$class(styles.center_search_tooltip)
    }
  }

  //关闭提示
  bindCloseBubble() {
    this.$class(styles.closeSaveTips).click(() => {
      this.$class(styles.closeSaveTips).parent().hide() ;
      this.$emit(EEventType.onCloseSaveTips)
    })
    
  }

  protected bindResetClick() {
    this.$class(styles.center_reset).click(() => {
      this.$emit(EEventType.onReset)
    })
  }

  protected bindSaveClick() {
    this.$class(styles.center_save).click(() => {
      this.$emit(EEventType.onSave, {tags: JSON.parse(JSON.stringify(this.props.tags)), filterType: 10})
    })
  }

  protected bindNewClick() {
    this.$class(styles.center_new).click(() => {
      this.$emit(EEventType.onSave, {tags: JSON.parse(JSON.stringify(this.props.tags)), filterType: 20})
    })
  }

  protected bindClose() {
    this.$class(styles.chacha).click(() => {
      this.$class(styles.big_white_box).hide()
      this.$class(styles.triangle).hide()
    })
  }

  // 渲染按钮抛出事件
  renderButton() {
    let { tags } = this.props
    let that = this
    this.$el.find('oy-button').each((_ind, element) => {
      const $element = $(element)
      $element.OYButton({
        onClick: function(ev: Event) {
          if ($element.hasClass('center_new2')) {
            that.$class(styles.big_white_box).hide()
            that.$class(styles.triangle).hide()
            that.$emit(EEventType.onSave, {tags: JSON.parse(JSON.stringify(tags)), filterType: 20})
          }
          if ($element.hasClass('no_attention')) {
            that.$class(styles.big_white_box).hide()
            that.$class(styles.triangle).hide()
            localStorage.setItem("IS_HIDE_FILTER_TPL",JSON.stringify(true))
          }
        }
      })
    })
  }

  protected bindFeedbackIcon() {
    this.$class(styles.feedbakIcon).click(() => {
      this.$emit(EFilterBarEvent.onFeedbackClick)
    })
  }

  protected bindFastQueryIcon() {
    this.$class(styles.center_search).hover(
      () => {
        if (this.props.showFastQueryList) {
          this.$node.center_search_tooltip.show();
          this.saveList.setScrollPosition();
        }
      },
      () => {
        this.$node.center_search_tooltip.hide()
      }
    )
  }

  protected bindSaveIconClick() {
    this.$class(styles.saveIcon).click(() => {
      this.eventEmitter.emit(EFilterBarEvent.onSaveIconClick)
    })
  }

  // TODO: 这个逻辑已经废弃，移除tooltip的逻辑
  // protected bindFeedbackCloseIcon() {
  //   this.$el.find(`.${styles.tooltipCloseIcon}`).click((ev: Event) => {
  //     $(`.${styles.center_feedback_tooltip}`).hide();
  //     this.$emit(EFilterBarEvent.onFeedbackClose)
  //   })
  // }
}



// WEBPACK FOOTER //
// ./src/components/OYFilterBar/index.ts